import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { List, ListItem, Typography, Button } from '@mui/material'
import { DeleteForever as DeleteIcon } from '@mui/icons-material'

import { destroyPageAsync, selectPageIsMine, selectPageTitle } from './pagesSlice'

const classes = {
  listItem: {
    flexWrap: 'wrap',
  },
  button: { margin: 1 },
}

export default function DeletePage({ pageId }) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const hasValidPageId = Number.isFinite(pageId)
  const isMine = useSelector(selectPageIsMine(pageId))
  // Someone else's page isn't mine to delete, and the server would refuse. Only
  // its owner can delete it, or stop sharing it with me.
  const canDelete = hasValidPageId && isMine
  const title = useSelector(selectPageTitle(hasValidPageId ? pageId : null))

  // Nothing to offer about someone else's page: not a disabled button, not an
  // explanation, just absent. Deleting it isn't mine to do, and taking away the
  // share isn't either.
  if (hasValidPageId && !isMine) {
    return null
  }

  const handleClick = (e) => {
    if (!canDelete) {
      return
    }
    // console.log('<DeletePage />.handleClicked()')
    navigate(`/app/pages`)
    dispatch(destroyPageAsync(pageId))
    e.stopPropagation()
  }

  return (
    <List>
      <ListItem sx={classes.listItem}>
        <Typography variant='h6'>Delete current page</Typography>
        <Typography variant='caption' component='div'>
          {!hasValidPageId && 'No current page selected'}
          {canDelete && (
            <React.Fragment>
              This will delete <b>{title}</b>
            </React.Fragment>
          )}
        </Typography>
        <Button
          sx={classes.button}
          color='warning'
          variant='contained'
          aria-label='delete page'
          onClick={handleClick}
          disabled={!canDelete}
          endIcon={<DeleteIcon />}
        >
          Delete
        </Button>
        <Typography variant='caption' component='div'>
          <em>Warning, this cannot be undone!</em>
        </Typography>
      </ListItem>
    </List>
  )
}
